import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {

  @Input() type = '';

  @Input() contacts?: {
    department: string;
    phone?: string;
    email?: string;
    address?: string;
  }[];

  @Input() content?: {
    text: string;
    link?: string;
  }[];

  formNotSubmitted$ = new BehaviorSubject(true);

  onSubmit() {
    this.formNotSubmitted$.next(false);
  }
}
